import { Action } from '@ngrx/store';
import { IOrganization } from '../../../../commons';

export enum OrganizationActionTypes {
  LoadOrganizationState = '[Organization] Load Organization State',
  LoadOrganizationStateSuccess = '[Organization] Load Organization State Success',
  LoadOrganizationStateFail = '[Organization] Load Organization State Fail',
  OrganizationScreenErrorReset = '[Organization] Organization Screen Error Reset'

}

export class LoadOrganizationState implements Action {
  readonly type = OrganizationActionTypes.LoadOrganizationState;
}

export class LoadOrganizationStateSuccess implements Action {
  readonly type = OrganizationActionTypes.LoadOrganizationStateSuccess;
  constructor(public payload: IOrganization ) {}
}

export class LoadOrganizationStateFail implements Action {
  readonly type = OrganizationActionTypes.LoadOrganizationStateFail;
  constructor(public payload: any) {}
}

export class OrganizationScreenErrorReset implements Action {
  readonly type = OrganizationActionTypes.OrganizationScreenErrorReset;
}

export type OrganizationActions = 
  LoadOrganizationState
  | LoadOrganizationStateSuccess
  | LoadOrganizationStateFail
  | OrganizationScreenErrorReset;